import React from "react";
import HeaderComponent from "./HeaderComponent";
import Newsletter from "./Newsletter";

const SponsorUs = () => {
  return (
    <>
      <HeaderComponent />
      <div className="container mx-auto px-6 py-12 text-center">
        <h1 className="text-4xl font-bold text-gray-900">
          Become a Partner/Sponsor Us
        </h1>

        <p className="  mt-3 max-w-2xl mx-auto">
          Gain exposure to thousands of tech professionals and newbies by
          sponsoring or partnering with us for the Future of Technology African
          Conference
        </p>

        <div className="mt-20 text-left max-w-3xl mx-auto space-y-6">
          {/* Corporate Responsibility */}
          <div>
            <h2 className="text-xl font-semi-bold text-[#F63A0A] mb-2">
              1. CORPORATE RESPONSIBILITY
            </h2>
            <p className="text-gray-700">
              Forward-thinking companies choose partners who share their values.
              By sponsoring TechX Africa, you demonstrate your commitment to our
              mission: building a brighter, more accessible future for all.
            </p>
          </div>

          {/* Brand Visibility */}
          <div>
            <h2 className="text-xl font-semi-bold text-[#F63A0A] mb-2">
              2. BRAND VISIBILITY AND EXPOSURE
            </h2>
            <p className="text-gray-700">
              Become a recognized name among tech professionals, thought
              leaders, and enthusiasts. We'll showcase your brand in conference
              materials, promotional content, and across key channels, giving
              you maximum exposure within the tech community.
            </p>
          </div>

          {/* Valuable Connections */}
          <div>
            <h2 className="text-xl font-semi-bold text-[#F63A0A] mb-2">
              3. Gain Valuable Connections:
            </h2>
            <p className="text-gray-700">
              Forge relationships with industry leaders, potential clients, and
              key decision-makers, including government officials. Sponsorship
              grants you access to exclusive events, where you can connect and
              build relationships that can lead to lucrative partnerships,
              collaborations, and business opportunities.
            </p>
          </div>

          {/* Leadership in Tech Advancement */}
          <div>
            <h2 className="text-xl font-semi-bold text-[#F63A0A] mb-2">
              4. Become a leader in tech advancement
            </h2>
            <p className="text-gray-700">
              Sponsoring TechX Africa positions your brand alongside the most
              progressive minds in technology, showcasing your commitment to
              staying ahead of the curve.
            </p>
          </div>
        </div>

        {/* Download Proposal Button */}
        <a
          href="/TXA 25 Official Proposal.pdf" // File is in public folder
          className="mt-14 inline-block bg-primary text-white py-3 px-6 rounded-sm text-lg font-semibold 
             shadow-md hover:shadow-lg transition-all"
          download="TXA 25 Official Proposal.pdf" 
        >
          Download Proposal Here
        </a>
      </div>

    </>
  );
};

export default SponsorUs;
